import { createSlice } from '@reduxjs/toolkit'

import { vehicleParts } from '../../components/inventory/viewVehicle.description'

const initialState = {
  activeTab: {},
  partMenuTab: vehicleParts.doorParts,
}

const inventoryReducer = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setVehicleActiveTab: (state, action) => {
      state.activeTab = { ...state.activeTab, ...action.payload }
    },
    setPartMenuActiveTab: (state, action) => {
      state.partMenuTab = action.payload
    },
  },
})

export const { setVehicleActiveTab, setPartMenuActiveTab } =
  inventoryReducer.actions

export default inventoryReducer.reducer
